import { useMutation, useQueryClient } from "react-query";
import {
  activateDeliveryCheckout,
  activateInstoreCheckout,
  activateOrderType,
  activateScheduleDeliveryCheckout,
  activateStorefrontPayment,
} from "../../../../../../../../../services/inventory";
import { useContext, useState } from "react";
import { ToastContext } from "../../../../../../../../../hooks/context";
import { useParams, useSearchParams } from "react-router-dom";

export const useCheckout = () => {
  const { menuId } = useParams();
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const menu_id = searchParams.get("menu_id");
  const [scheduleData, setSheduleData] = useState(false);

  // useEffect(() => {
  //   queryClient.invalidateQueries(["getStorefrontDetails"]);
  // }, [queryClient]);

  const { isLoading: isLoadingActivate, mutate: mutateActivate } = useMutation({
    mutationFn: () => activateStorefrontPayment(menuId ? menuId : menu_id),
    onSuccess: (data) => {
      triggerToast(data?.data?.detail, "success");
      queryClient.invalidateQueries(["getStorefrontDetails"]);
    },
    onError: (error) => {
      triggerToast(`${error?.response?.data?.message}`, "warning");
    },
  });

  const {
    isLoading: isLoadingActivateInstoreCheckout,
    mutate: mutateActivateInstoreCheckout,
  } = useMutation({
    mutationFn: () => activateInstoreCheckout(menuId ? menuId : menu_id),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      queryClient.invalidateQueries(["getStorefrontDetails"]);
    },
    onError: (error) => {
      triggerToast(`${error?.response?.data?.message}`, "warning");
    },
  });

  const { mutate: mutateActiveOrderType } = useMutation({
    mutationFn: () => activateOrderType(menuId ? menuId : menu_id),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      queryClient.invalidateQueries(["getStorefrontDetails"]);
    },
    onError: (error) => {
      triggerToast(`${error?.response?.data?.message}`, "warning");
    },
  });

  const {
    isLoading: isLoadingActivateDeliveryCheckout,
    mutate: mutateActivateDeliveryCheckout,
  } = useMutation({
    mutationFn: () => activateDeliveryCheckout(menuId ? menuId : menu_id),
    onSuccess: (data) => {
      triggerToast(data?.data?.detail, "success");
      queryClient.invalidateQueries(["getStorefrontDetails"]);
    },
    onError: (error) => {
      triggerToast(`${error?.response?.data?.message}`, "warning");
    },
  });

  const { mutate: mutateActiveScheduleDelivery } = useMutation({
    mutationFn: () => activateScheduleDeliveryCheckout(menuId || menu_id),
    onSuccess: (data) => {
      triggerToast(data?.data?.detail, "success");
      queryClient.invalidateQueries(["getStorefrontDetails"]);
    },
  });

  return {
    isLoadingActivate,
    isLoadingActivateInstoreCheckout,
    isLoadingActivateDeliveryCheckout,
    mutateActiveOrderType,
    mutateActivate,
    mutateActivateInstoreCheckout,
    mutateActivateDeliveryCheckout,
    scheduleData,
    setSheduleData,
    mutateActiveScheduleDelivery,
  };
};
